import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Modal from "~/js/common/modal";
import HeaderMenu from "./headerMenu";
import Selector from "./selector";
import Tooltip from "~/js/common/tooltip";
import DropdownSelector from "~/js/common/dropdownSelector";
import noUiSlider from "nouislider";
export default class ECSearchMain {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    this.header = new Header();
    this.footer = new Footer();
    this.modal = new Modal();

    this.headerMenu = new HeaderMenu();
    this.selector = new Selector();
    this.tooltip = new Tooltip();
    store.dispatch("init");

    // ドロップダウン制御を共通クラスに委譲
    const searchEl = document.querySelector('.ec-search');
    if (searchEl) {
      this.dropdown = new DropdownSelector(searchEl, { prefix: '' });
    }

    this.setupClear();
    this.setupPriceSlider();
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }

  /**
   * クリアボタン押下時
   */
  setupClear() {
    const clearbutton = document.querySelector(".js-clear");
    if (clearbutton) {
      clearbutton.addEventListener("click", () => {
        if (this.dropdown) {
          this.dropdown.clearAllSelections();
        }

        // 価格スライダーをリセット
        if (this.priceSlider && this.priceSliderConfig) {
          this.priceSlider.set([this.priceSliderConfig.defaultMin, this.priceSliderConfig.defaultMax]);
        }
      });
    }
  }

  /**
   * 価格スライダーのセットアップ
   */
  setupPriceSlider() {
    const sliderElement = document.querySelector('.js-price-slider');
    if (!sliderElement) {
      this.priceSlider = null;
      return;
    }

    const minInput = document.querySelector('.js-price-min-input');
    const maxInput = document.querySelector('.js-price-max-input');
    const minPriceDisplay = document.querySelector('.min-price');
    const maxPriceDisplay = document.querySelector('.max-price');

    // 設定値（上限はdata属性から取得、未設定または0の場合はデフォルト値を使用）
    const maxPriceFromSettings = parseInt(sliderElement.dataset.maxPrice, 10);
    const sliderMax = (isNaN(maxPriceFromSettings) || maxPriceFromSettings <= 0) ? 500000 : maxPriceFromSettings;
    const PRICE_SLIDER_CONFIG = {
      step: 1000,
      min: 0,
      max: sliderMax,
      defaultMin: 0,
      defaultMax: sliderMax
    };
    this.priceSliderConfig = PRICE_SLIDER_CONFIG;

    // URLパラメータから初期値を取得（price_1/price_2 と filter.v.price.gte/lte の両方に対応）
    const urlParams = new URLSearchParams(window.location.search);

    // URLパラメータから価格を取得（0も有効な値として扱う）
    const minPriceParam = urlParams.get('filter.v.price.gte') || urlParams.get('price_1');
    const maxPriceParam = urlParams.get('filter.v.price.lte') || urlParams.get('price_2');

    // 価格パラメータのパース処理（空文字列とNaNを考慮）
    const parsePrice = (param, defaultValue) => {
      if (!param || param === '') return defaultValue;
      const parsed = parseInt(param, 10);
      return isNaN(parsed) ? defaultValue : parsed;
    };

    const minPrice = parsePrice(minPriceParam, PRICE_SLIDER_CONFIG.defaultMin);
    const maxPrice = parsePrice(maxPriceParam, PRICE_SLIDER_CONFIG.defaultMax);

    // noUiSlider初期化
    this.priceSlider = noUiSlider.create(sliderElement, {
      start: [minPrice, maxPrice],
      connect: true,
      step: PRICE_SLIDER_CONFIG.step,
      range: {
        'min': PRICE_SLIDER_CONFIG.min,
        'max': PRICE_SLIDER_CONFIG.max
      },
      format: {
        to: (value) => Math.round(value),
        from: (value) => Number(value)
      }
    });

    // スライダー値変更時の処理
    this.priceSlider.on('update', (values) => {
      const minValue = Number(values[0]);
      const maxValue = Number(values[1]);

      // 価格表示を更新（ロケール明示）
      minPriceDisplay.textContent = minValue.toLocaleString('ja-JP');
      maxPriceDisplay.textContent = maxValue.toLocaleString('ja-JP');

      // 隠し入力フィールドに値を設定
      minInput.value = minValue;
      maxInput.value = maxValue;
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ECSearchMain();
});
